import React from 'react';
import {
	NavLink,
	Link
} from 'react-router-dom'


class ProjectGrid extends React.Component {
    constructor(props) {
        super(props);
        this.handleClick = this.handleClick.bind(this);
        document.querySelector('body').classList.remove('fp-scroll-false');
    }


    handleClick(e){
        let {fullpageApi} = this.props;
        if(fullpageApi){
            if(document.querySelector('body').classList.contains('fp-scroll-false')){
                fullpageApi.setAllowScrolling(true);
                document.querySelector('body').classList.remove('fp-scroll-false');
            }
            else{
                fullpageApi.setAllowScrolling(false);
                document.querySelector('body').classList.add('fp-scroll-false');
            }
            
        }
    }
    
    componentDidMount() {

        // accordian
        const accordions = document.querySelectorAll(".accordion");

        const openAccordion = (accordion) => {
            const accordContent = accordion.querySelector(".accordion__content");
            accordion.classList.add("accordion__active");
            accordContent.style.height = accordContent.scrollHeight + "px";
        };

        const closeAccordion = (accordion) => {
            const accordContent = accordion.querySelector(".accordion__content");
            accordion.classList.remove("accordion__active");
            accordContent.style.height = null;
        };

        accordions.forEach((accordion) => {
            const accordBtn = accordion.querySelector(".accordion__btn");
            const accordContent = accordion.querySelector(".accordion__content");

            accordBtn.onclick = () => {
                if (accordContent.style.height) {
                    closeAccordion(accordion);
                } else {
                    accordions.forEach((accordion) => closeAccordion(accordion));
                    openAccordion(accordion);
                }
            };
        });

        
        // get current filter item
        let cfitem = document.getElementById('filtered-item');
        let fItems = document.querySelectorAll('.project-filter-items a');
        
        fItems.forEach(fItem => {
            fItem.addEventListener('click', () => {
                document.querySelector('.accordion').classList.remove('accordion__active');
                document.querySelector('.accordion__content').removeAttribute('style');
            });
        });
    }


    render() {
        let {type, category, loadedProjects} = this.props;
        return (
            <section className="mole__projects--nav">
                <div className="main-container">
                    <div className="inner-container">
                        <h6 className="font-lg-head c-general w-100" id="filtered-item">{category.name}</h6>

                        <div className="w-100 inner-grid">
                            <div className="project-viewers">
                                <div className="project-view">
                                    <NavLink activeClassName="nav-actv" to={`${process.env.PUBLIC_URL}/project/grid/${category.slug}`}>Grid View</NavLink>
                                    <NavLink activeClassName="nav-actv" to={`${process.env.PUBLIC_URL}/project/detail/${category.slug}`}>Detail View</NavLink>
                                </div>

                                <div className="project-filter accordion  noraml-scroll-elem">
                                    <a href="javascript:" className="accordion__btn" id="btn--filter" onClick={this.handleClick}>Filter</a>
                                    <div className="project-filter-items accordion__content">
                                        <NavLink activeClassName="nav-actv" exact to={`${process.env.PUBLIC_URL}/project/${type}/selected`}>Selected</NavLink>
                                        <NavLink activeClassName="nav-actv" exact to={`${process.env.PUBLIC_URL}/project/${type}`}>All</NavLink>
                                        <NavLink activeClassName="nav-actv" exact to={`${process.env.PUBLIC_URL}/project/${type}/community`}>Community</NavLink>
                                        <NavLink activeClassName="nav-actv" exact to={`${process.env.PUBLIC_URL}/project/${type}/house`}>House</NavLink>
                                        <NavLink activeClassName="nav-actv" exact to={`${process.env.PUBLIC_URL}/project/${type}/housing`}>Housing</NavLink>
                                        <NavLink activeClassName="nav-actv" exact to={`${process.env.PUBLIC_URL}/project/${type}/workspace`}>Workspace</NavLink>
                                    </div>
                                </div>
                            </div>
                           
                            <article className="project--category--caption font-md">
                                <p className="caption--Selected" style={{display:'block'}} dangerouslySetInnerHTML={{__html: category.description}} />
                            </article>
                        </div>

                       
                    </div>
                </div>
            </section>
        );
    }
}
export default ProjectGrid;



// WEBPACK FOOTER //
// ./src/components/Projects/ProjectNav.js